<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="商品入库"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-form-item label="商品名称" prop="goodsImage">
				{{item.name}}
			</el-form-item>
			<div>
				<!-- <p style="margin:22px 0 10px 0">价格</p> -->
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable" :data="item" border
					tooltip-effect="dark">
					<el-table-column label="商品规格" prop="sku_name" align="center">
					</el-table-column>
					<el-table-column label="当前库存（件）">
						<template slot-scope="scope">
							<el-input :value = "scope.row.stock" disabled></el-input>
						</template>
					</el-table-column>
					<el-table-column label="入库数量（件）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.storkin_num"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>


			<el-form-item>
				<el-button type="primary" @click="submit" v-auth="['store/stock/addStockIn']">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				options: [],
				optionsSub: []
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData: async function() {
				// 获取商品信息
				await this.axios.post('/store/stock/detail', {
					id: this.id
				}).then(res => {
					this.item = res.data.sku
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let arr = []
				this.item.forEach(res => {
					if(res.storkin_num){
						arr.push({
							sku_name: res.sku_name,
							unique: res.unique,
							storkin_num: res.storkin_num
						})
					}
				})
				// 入库操作
				let url = '/store/stock/addStockIn'
				this.axios.post(url, {
					stock: arr,
					id: this.id
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
					this.goBack()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			}
		}
	}
</script>
<style scoped>
</style>
